export const LinkedInAndTwitterEvents = {
    enter_email: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6ds8&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
            "//t.co/i/adsct?txn_id=o6ds8&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],

        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466796&fmt=gif",
    },
    create_password: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6ds9&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",

            "//t.co/i/adsct?txn_id=o6ds9&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466812&fmt=gif",
    },
    enter_phone: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6dsa&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
            "//t.co/i/adsct?txn_id=o6dsa&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466820&fmt=gif",
    },
    answer_minimum_capital: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6dsb&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
            "//t.co/i/adsct?txn_id=o6dsb&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466828&fmt=gif",
    },
    click_fund_account: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6dsd&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
            "//t.co/i/adsct?txn_id=o6dsd&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466836&fmt=gif",
    },
    fund_account: {
        twitter: [
            "https://analytics.twitter.com/i/adsct?txn_id=o6dse&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
            "//t.co/i/adsct?txn_id=o6dse&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0",
        ],
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466844&fmt=gif",
    },
};
